import { Button, Col, Form, Input, InputNumber, Row, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import "./ModalAddService.scss";
import { allColumns, allColumnsBHYT, allColumnsTPTG, dataBHYT } from "./config";
import Icons from "assets/icons";
import consultantAndFragmentService from "api/consulantAndFragtment";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Notification } from "components/common";
import { setDataConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import { formatToCurrencyType } from "helper/common";
import { ColumnsEdit } from "types/models/column-table-edit";
import TinhTongGia from "./tinhTien";

const ModalAddService = ({
  dataServicePaket,
  setParams,
  modalAddService,
  params,
}) => {
  const dispatch = useAppDispatch();
  const dataConsultantAndFragment = useAppSelector(
    (e) => e.consultantAndFragment.data
  );

  const [form] = Form.useForm();
  const [formInput] = Form.useForm();
  const idConsultantAndFragment = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantAndFragment
  );
  const [datatb1, setDataTb1] = useState(null);
  const [columnsBHYT, setColumnsBHYTt] = useState<ColumnsEdit>(allColumnsBHYT);
  // const [dataBHYT, setDataBHYT] = useState(dataBHYTInit);
  const [dataSelected, setDataSelected] = useState(null);
  const [datatb2, setDataTb2] = useState(null);
  const [options, setOptions] = useState([]);
  const [goiDichVu, setGoiDichVu] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isBlur, setIsBlur] = useState(true);

  const [valueCusstom, setValueCustom] = useState<any>(null);
  // const [selectedRowKeysDetailPacket, setSelectedRowKeysDetailPacket] =
  //   useState<React.Key[]>([]);

  // THêm gói dịch vụ
  const handlePostServicePacket = async () => {
    if (idConsultantAndFragment !== null) {
      try {
        const data = {
          idPhieuTuVan: idConsultantAndFragment,
          ngayTao: dataConsultantAndFragment.ngayTao,
          idGoiDichVus: goiDichVu && goiDichVu.map((item) => item.id),
        };

        const res = await consultantAndFragmentService.postServicePacket(data);

        const newRes = {
          ...dataConsultantAndFragment,
          dmGoiDichVuDtos: res.dmGoiDichVuDtos,
        };

        dispatch(setDataConsultantAndFragment(newRes));

        handleCancle();
        Notification("success", "Bổ sung dịch vụ thành công ");
      } catch (error) {
        Notification("error", "Bổ sung dịch vụ không thành công");
      }
    }
  };

  const getStatusCaltalog = async () => {
    try {
      const res = await consultantAndFragmentService.getStatusCatalog();
      allColumns.find((e) => e.dataIndex === "trangThai").render = (text) => {
        return res.find((e) => e.id == text).tenTTDichVuKyThuat;
      };
      setOptions(res);
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy trạng thái gói bổ sung dịch vụ"
      );
    }
  };

  useEffect(() => {
    getStatusCaltalog();
  }, [dataServicePaket]);

  const handleChange = (e) => setValueCustom(e);

  
  // xử lý logic tổng phí BH
  useEffect(() => {
    // const giaBHYT =dataSelected.map(item=>) Math.floor(
    //   datatb2?.reduce((total, item) => total + item.giaBHYT, 0)
    // );
    // const giaBv = Math.floor(
    //   datatb2?.reduce((total, item) => total + item.giaBv, 0)
    // );
    const tongGiaBHYT = TinhTongGia(dataSelected, "giaBH");
    const tongGiaBv = TinhTongGia(dataSelected, "giaBv");
    const mucBVGiam = TinhTongGia(dataSelected, "mucBVGiam");
    const res = allColumnsBHYT.map((e) => {
      if (e.dataIndex === "mucBH") {
        e.render = (v, r, i) => {
          if (i === 0) {
            return <div>100%</div>;
          } else if (i === 1) {
            return <div>95%</div>;
          } else if (i === 2) {
            return <div>80%</div>;
          } else {
            return <InputNumber onChange={handleChange} controls={false} />;
          }
        };
      }

      if (e.dataIndex === "giaBHYT") {
        e.render = (v, r, i) => {
          return (
            <div>
              {i === 0 && tongGiaBHYT > 0 && formatToCurrencyType(tongGiaBHYT)}
              {i === 1 &&
                tongGiaBHYT > 0 &&
                formatToCurrencyType(Math.round(tongGiaBHYT * 0.95))}
              {i === 2 &&
                tongGiaBHYT > 0 &&
                formatToCurrencyType(Math.round(tongGiaBHYT * 0.8))}
              {
                i === 3 &&
                  tongGiaBHYT > 0 &&
                  valueCusstom > 0 &&
                  // !isNaN(valueCusstom)
                  formatToCurrencyType(
                    Math.floor(tongGiaBHYT * (valueCusstom / 100))
                  )
                // : formatToCurrencyType(
                //     tongGiaBHYT * (valueCusstom?.replace(/%/g, "") / 100)
              }
            </div>
          );
        };
      }

      if (e.dataIndex === "nbDongChiTra") {
        e.render = (v, r, i) => {
          return (
            <div>
              {i === 0 &&
                tongGiaBHYT > 0 &&
                formatToCurrencyType(tongGiaBHYT * 0)}
              {i === 1 &&
                tongGiaBHYT > 0 &&
                formatToCurrencyType(Math.round(tongGiaBHYT * (1 - 0.95)))}
              {i === 2 &&
                tongGiaBHYT > 0 &&
                formatToCurrencyType(Math.round(tongGiaBHYT * (1 - 0.8)))}
              {i === 3 &&
                tongGiaBHYT > 0 &&
                valueCusstom > 0 &&
                formatToCurrencyType(
                  Math.floor(tongGiaBHYT * (1 - valueCusstom / 100))
                )}
            </div>
          );
        };
      }
      if (e.dataIndex === "nbTuTra") {
        e.render = (v, r, i) => {
          return i === 3 ? (
            valueCusstom && (
              <div>
                {isNaN(tongGiaBv - tongGiaBHYT)
                  ? 0
                  : formatToCurrencyType(Math.round(tongGiaBv - tongGiaBHYT))}
              </div>
            )
          ) : (
            <div>
              {isNaN(tongGiaBv - tongGiaBHYT)
                ? 0
                : formatToCurrencyType(Math.round(tongGiaBv - tongGiaBHYT))}
            </div>
          );
        };
      }
      if (e.dataIndex === "tongnbTra") {
        e.render = (v, t, i) => (
          <div>
            {i === 0 &&
              tongGiaBHYT > 0 &&
              formatToCurrencyType(
                Math.round((tongGiaBv - tongGiaBHYT) / 1000) * 1000
              )}
            {i === 1 &&
              tongGiaBHYT > 0 &&
              formatToCurrencyType(
                Math.round(
                  (tongGiaBHYT * (1 - 0.95) +
                    (tongGiaBv - tongGiaBHYT) -
                    mucBVGiam) /
                    1000
                ) * 1000
              )}
            {i === 2 &&
              tongGiaBHYT > 0 &&
              formatToCurrencyType(
                Math.round(
                  (tongGiaBHYT * (1 - 0.8) +
                    (tongGiaBv - tongGiaBHYT) -
                    mucBVGiam) /
                    1000
                ) * 1000
              )}
            {i === 3 &&
              tongGiaBHYT > 0 &&
              valueCusstom > 0 &&
              formatToCurrencyType(
                Math.round(
                  (tongGiaBHYT * (1 - valueCusstom / 100) +
                    (tongGiaBv - tongGiaBHYT) -
                    mucBVGiam) /
                    1000
                ) * 1000
              )}
          </div>
        );
      }
    });

    setColumnsBHYTt([res]);
  }, [goiDichVu, valueCusstom]);

  allColumns.find((e) => e.dataIndex === "stt").render = (v, r, i) =>
    (params.page - 1) * params.limit + i + 1;
  // Chọn gói dịch vụ
  const rowSelectionServicepacket = {
    selectedRowKeys,
    onChange: async (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys);

      if (selectedRows.length !== 0) {
        selectedRows.map((item) => {
          if (item.chiTietGoiDichVuDtos) {
            const chiTietGoiDichVuDtosArray = item.chiTietGoiDichVuDtos.map(
              (item) => ({
                ...item,
                key: item.id,
              })
            );
            setDataTb1((prevData) => {
              const newData = prevData
                ? [...prevData, ...chiTietGoiDichVuDtosArray]
                : chiTietGoiDichVuDtosArray;

              const uniqueData = Array.from(
                new Set(newData.map((item) => item.key))
              ).map((key) => newData.find((item) => item.key === key));

              return uniqueData;
            });
          } else setDataTb1(null);
        });

        setDataSelected(selectedRows);

        setGoiDichVu(selectedRows);
      } else {
        setDataSelected(null);
        setDataTb1(null);
        // setSelectedRowKeysDetailPacket(null);
        setColumnsBHYTt(allColumnsBHYT);
        setSelectedRowKeys(null);
      }
    },
    // hideSelectAll: true,
    // selections: [Table.SELECTION_NONE],
  };
  // const rowSelection = {
  //   selectedRowKeys: selectedRowKeysDetailPacket,
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
  //     setSelectedRowKeysDetailPacket(selectedRowKeys);
  //     setDataTb2(selectedRows);
  //   },
  // };

  const handleCancle = () => {
    modalAddService?.current.closeModal();
    // setSelectedRowKeysDetailPacket([]);
    setDataTb1(null);
    setSelectedRowKeys([]);
    setGoiDichVu(null);
  };

  useEffect(() => {
    if (selectedRowKeys === null) {
      setDataTb1(null);
      // setDataTb2(null);
      setGoiDichVu(null);
    }
  }, [selectedRowKeys]);
  const onChangePagination = (page: number, pageSize: number) => {
    setParams({
      page: page,
      limit: pageSize,
    });
  };

  const handleSearch = () => {
    const value = formInput.getFieldValue("tenGoi");
    setParams({
      ...params,
      tenGoiDichVu: value,
      page: 1,
    });
  };
  return (
    <div>
      <div className="container modal-add-service">
        <Form form={formInput}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Form.Item
              name={"tenGoi"}
              label="Tên gói"
              labelCol={{ xl: 3 }}
              labelAlign="left"
            >
              <Input
                placeholder="Nhập"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSearch}>
                Tìm kiếm
              </Button>
            </Form.Item>
          </Space>
        </Form>
      </div>

      <div className="container">
        <Space direction="vertical">
          <Row gutter={[16, 8]}>
            <Col xl={15}>
              <div className="header">Danh sách gói dịch vụ</div>
              <Table
                columns={allColumns}
                dataSource={dataServicePaket}
                // pagination={{
                //   position: ["bottomRight"],
                //   // showSizeChanger: true,
                //   total: total,
                //   onChange: onChangePagination,
                //   // current: params.page,
                // }}
                pagination={false}
                bordered
                rowSelection={{
                  ...rowSelectionServicepacket,
                }}
                scroll={{ x: "100%", y: 500 }}
              />
            </Col>
            <Col xl={9}>
              <Row>
                <div className="header">Tổng chi phí có BH</div>
                <Form form={form}>
                  <Table
                    dataSource={dataBHYT}
                    columns={allColumnsBHYT}
                    pagination={false}
                    bordered
                    scroll={{ x: 600, y: 2000 }}
                  />
                </Form>
              </Row>
              <Row>
                <div className="header">Thành phần trong gói</div>

                <Table
                  columns={allColumnsTPTG}
                  dataSource={datatb1}
                  pagination={false}
                  bordered
                  scroll={{ x: 800, y: 500 }}
                />
              </Row>
            </Col>
          </Row>
          <Row justify={"end"}>
            <Space>
              <Button type="default" danger onClick={handleCancle}>
                Hủy
              </Button>
              <Button
                type="primary"
                className="btn-sub"
                onClick={handlePostServicePacket}
                disabled={goiDichVu ? false : true}
              >
                Lưu gói
              </Button>
            </Space>
          </Row>
        </Space>
      </div>
    </div>
  );
};

export default ModalAddService;
